"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputError = void 0;
var react_1 = __importDefault(require("react"));
var InputError = function (props) {
    return (react_1.default.createElement("div", { className: "mt-2 text-center text-danger", style: { whiteSpace: "pre-wrap" } }, props.message));
};
exports.InputError = InputError;
